module.exports = __webpack_public_path__ + "media/images/Arrow-cb9e37e8.svg";